function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBitbucket = function SvgBitbucket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#205081",
    fillRule: "nonzero",
    d: "M15.86 0C8.23 0 2 2.05 2 4.6c0 .67 1.66 10.3 2.32 14.1.3 1.7 4.72 4.22 11.54 4.22v-.02.02c6.82 0 11.24-2.5 11.54-4.22.66-3.8 2.32-13.43 2.32-14.1 0-2.55-6.23-4.6-13.86-4.6zm0 19.83c-2.43 0-4.4-1.97-4.4-4.4 0-2.44 1.97-4.4 4.4-4.4 2.43 0 4.4 1.96 4.4 4.4 0 2.43-1.97 4.4-4.4 4.4zm0-13.8c-4.9-.02-8.88-.87-8.88-1.9 0-1.06 3.98-1.9 8.88-1.9 4.9.02 8.88.87 8.88 1.92 0 1.04-3.98 1.88-8.88 1.87zm9.96 16.5c-.2 0-.38.15-.38.15s-3.4 2.7-9.58 2.7c-6.17 0-9.58-2.7-9.58-2.7s-.17-.15-.38-.15c-.25 0-.5.17-.5.54 0 .04 0 .08.02.12l.98 5.13c.47 2.1 4.55 3.66 9.46 3.66 4.92 0 9-1.58 9.46-3.67.07-.3.45-2.32.98-5.15v-.13c0-.37-.23-.54-.48-.54zm-7.76-7.1c0 1.2-.98 2.2-2.2 2.2-1.22 0-2.2-1-2.2-2.2 0-1.22.98-2.2 2.2-2.2 1.22 0 2.2.98 2.2 2.2z",
    style: {
      fill: "#205081"
    }
  })));
};
export default SvgBitbucket;